import { ArrayUtil, Model, ModelRow } from "@mcleod/core";
import { AutogenLayoutEdiStatusOrderTab } from "./autogen/AutogenLayoutEdiStatusOrderTab";
import { EquipmentTypeQuickInfo } from "@mcleod/dispatch";
import { Layout } from "@mcleod/components";

export class EdiStatusOrderTab extends AutogenLayoutEdiStatusOrderTab {
    async CommodityIdOnDisplay(event) {
        if (this.activeRow != null) {
            const commodityId = this.activeRow.get("commodity_id");
            if (commodityId) {
                const response = await Model.searchSingleRecord("lme/dispatch/commodity", { id: commodityId });
                if (response != null) {
                    this.showHazmatWarning(response.get("hazmat"));
                    this.activeRow.set("commodity", response.get("descr"));
                }
            }
            this.textboxCommodityId.text = commodityId;
            await this.setCommodityQuickInfo(false, commodityId);
        }
    }

    async commodityCodeChanged() {
        if (this.activeRow != null) {
            const commodityCleared = this.activeRow.isNull("commodity_id");
            const lookupData = commodityCleared ? null : this.textboxCommodityId.getFirstLookupModelData();

            this.showHazmatWarning(lookupData?.get("is_hazmat"));
            this.activeRow.set("commodity", lookupData?.get("descr"));
            await this.setCommodityQuickInfo(true, this.activeRow.get("commodity_id"));
        }
    }

    async textboxTrailerTypeOnDataDisplay() {
        if (this.activeRow != null) {
            await this.setEquipmentTypeQuickInfo(false);
        }
    }

    async textboxTrailerTypeOnChange() {
        if (this.activeRow != null) {
            await this.setEquipmentTypeQuickInfo(true);
        }
    }

    showHazmatWarning(hazmat: string) {
        this.panelHazmat.borderWidth = hazmat === "Y" ? 1 : 0;
        this.panelHazmat.borderColor = hazmat === "Y" ? "error" : "";
        this.labelHazmatCommodity.visible = hazmat === "Y";
    }

    async setCommodityQuickInfo(hasChanged: Boolean, commodityID: string) {
        const partnerID = this.mainDataSource.activeRow?.get("partner_id");
        const version = this.mainDataSource.activeRow?.get("version");
        let partnerValue = this.mainDataSource.activeRow?.get("edi_commodity_id");
        if (hasChanged && commodityID != undefined) {
            const ediCommodityModelRow = await Model.searchSingleRecord("lme/datafusion/edi-commodity", { commodity_id: commodityID, partner_id: partnerID, version: version });
            if (ediCommodityModelRow != null) { partnerValue = ediCommodityModelRow.get("edi_commodity_id", ""); }
            else { partnerValue = ""; }
        }
        this.textboxCommodityId.quickInfoOverrideSearchMethod = async (layout: Layout, keyValue: any) => {
            await layout.mainDataSource.search({ id: keyValue });
            const row: ModelRow = ArrayUtil.getFirstElement(layout.mainDataSource?.data);
            if (row != null) {
                row.set("partner_value_visible", true);
                if (partnerValue != undefined) {
                    row.set("partner_value", partnerValue);
                }
            }
        };
    }

    async setEquipmentTypeQuickInfo(hasChanged: Boolean) {
        const partnerID = this.mainDataSource.activeRow?.get("partner_id");
        const version = this.mainDataSource.activeRow?.get("version");
        let partnerValue = this.mainDataSource.activeRow?.get("edi_equip_type_id");
        this.textboxTrailerType.quickInfoOverrideSearchMethod = async (layout: Layout, keyValue: any) => {
            const equipLayout = layout as EquipmentTypeQuickInfo;
            equipLayout.textboxPartnerValue.visible = true;
            await equipLayout.mainDataSource?.search({ search: keyValue });
            const modelRow: ModelRow = ArrayUtil.getFirstElement(equipLayout.mainDataSource?.data);
            if (hasChanged) {
                const ediCrossRefModelRow = await Model.searchSingleRecord("lme/datafusion/edi-cross-ref", { equipment_type_id: keyValue, partner_id: partnerID, version: version });
                if (ediCrossRefModelRow != null) { partnerValue = ediCrossRefModelRow.get("edi_code", ""); }
                else { partnerValue = ""; }
            }
            modelRow?.set("partner_value", partnerValue);
        };
    }

}
